// STATUS: draft — needs native-speaker check before live
// French visitor messages (task TR1, docs/modules/languages.md s2). Visitor keys only; missing keys fall back to en-GB.
export const frVisitor = {
    'kiosk.pairing.title': 'Configurer ce kiosque',
    'kiosk.pairing.hint': 'Saisissez le code du portail CloudSign.',
    'kiosk.pairing.go': 'Associer',
    'kiosk.pairing.codeLabel': 'Code d’association',
    'kiosk.pairing.checking': 'Vérification du code…',
    'kiosk.pairing.clear': 'Effacer',
    'kiosk.pairing.back': 'Supprimer le dernier chiffre',
    'kiosk.pairing.invalid': 'Ce code n’est pas valide ou a expiré. Demandez-en un nouveau.',
    'kiosk.pairing.noNetwork': 'Impossible de joindre CloudSign. Vérifiez le Wi-Fi et réessayez.',
    'kiosk.common.back': 'Retour',
    'kiosk.common.next': 'Suivant',
    'kiosk.common.continue': 'Continuer',
    'kiosk.common.cancel': 'Annuler',
    'kiosk.common.yes': 'Oui',
    'kiosk.common.no': 'Non',
    'kiosk.welcome.tap': 'Touchez ici pour vous enregistrer ou partir',
    'kiosk.welcome.offline': 'Hors connexion : les enregistrements sont sauvegardés et envoyés plus tard',
    'kiosk.home.title': 'Que souhaitez-vous faire ?',
    'kiosk.home.signIn': 'Enregistrer mon arrivée',
    'kiosk.home.signOut': 'Enregistrer mon départ',
    'kiosk.home.scan': 'Scanner mon badge',
    'kiosk.groups.titleIn': 'Qui êtes-vous ?',
    'kiosk.groups.titleOut': 'Qui quitte les lieux ?',
    'kiosk.groups.hint': 'Choisissez celle qui vous correspond le mieux.',
    'kiosk.groups.repeat': 'Membres habituels',
    'kiosk.pin.hint': 'Saisissez votre code PIN à 4 chiffres.',
    'kiosk.pin.entered': '{count} chiffres sur 4 saisis',
    'kiosk.pin.wrong': 'Ce code PIN n’est pas correct. Veuillez réessayer.',
    'kiosk.pin.locked': 'Trop de codes PIN incorrects. La saisie du code est bloquée pour quelques minutes. Veuillez demander de l’aide.',
    'kiosk.pin.clear': 'Effacer',
    'kiosk.pin.back': 'Supprimer le dernier chiffre',
    'kiosk.identify.title': 'Trouvez votre nom',
    'kiosk.identify.placeholder': 'Commencez à saisir votre nom',
    'kiosk.identify.none': 'Aucune personne trouvée sous ce nom.',
    'kiosk.identify.addSelf': 'Je ne suis pas sur la liste',
    'kiosk.addSelf.title': 'Ajoutez-vous',
    'kiosk.name.title': 'Quel est votre nom ?',
    'kiosk.name.label': 'Votre nom',
    'kiosk.name.fullNameHint': 'Veuillez indiquer votre prénom et votre nom de famille.',
    'kiosk.already.message': 'Vous êtes déjà enregistré. Souhaitez-vous plutôt enregistrer votre départ ?',
    'kiosk.already.signOut': 'Enregistrer mon départ',
    'kiosk.questions.titleIn': 'Quelques petites questions',
    'kiosk.questions.titleOut': 'Avant de partir',
    'kiosk.questions.datePlaceholder': 'YYYY-MM-DD',
    'kiosk.questions.acknowledge': 'J’ai bien compris',
    'kiosk.questions.hostSearch': 'Saisissez le nom de la personne que vous venez voir',
    'kiosk.questions.changeHost': 'Modifier',
    'kiosk.notices.progress': 'Avis {n} sur {total}',
    'kiosk.notices.accept': 'J’ai lu ceci et j’accepte',
    'kiosk.notices.sign': 'Signer',
    'kiosk.notices.signHere': 'Veuillez signer avec le doigt.',
    'kiosk.signature.pad': 'Zone de signature',
    'kiosk.signature.clear': 'Effacer la signature',
    'kiosk.signature.captured': 'Signature enregistrée',
    'kiosk.photo.title': 'Photo',
    'kiosk.photo.hint': 'Regardez la caméra et touchez le bouton.',
    'kiosk.photo.take': 'Prendre ma photo',
    'kiosk.photo.getReady': 'Préparez-vous…',
    'kiosk.photo.retake': 'Reprendre la photo',
    'kiosk.photo.use': 'Utiliser cette photo',
    'kiosk.photo.skip': 'Passer la photo',
    'kiosk.photo.failed': 'La photo n’a pas fonctionné. Veuillez réessayer.',
    'kiosk.photo.noCamera': 'La caméra n’est pas disponible. Vous pouvez continuer sans photo.',
    'kiosk.photo.privacy': 'Votre photo sert uniquement à votre badge et à votre fiche de visite.',
    'kiosk.badge.title': 'Votre badge',
    'kiosk.badge.ask': 'Souhaitez-vous un badge ?',
    'kiosk.badge.yes': 'Imprimer mon badge',
    'kiosk.badge.no': 'Non, merci, pas de badge',
    'kiosk.badge.printing': 'Impression de votre badge…',
    'kiosk.badge.done': 'Veuillez prendre votre badge',
    'kiosk.badge.failed': 'Désolé, le badge n’a pas pu être imprimé. Votre arrivée est enregistrée. Veuillez demander un badge à l’accueil.',
    'kiosk.signout.title': 'Trouvez votre nom pour partir',
    'kiosk.signout.search': 'Rechercher par nom',
    'kiosk.signout.hiddenHint': 'Pour des raisons de confidentialité, les noms ne sont pas affichés. Saisissez votre nom ou scannez votre badge.',
    'kiosk.signout.empty': 'Personne n’est enregistré.',
    'kiosk.signout.noMatch': 'Personne trouvé. Réessayez ou scannez votre badge.',
    'kiosk.signout.unnamed': 'Visiteur',
    'kiosk.scan.title': 'Scannez votre badge',
    'kiosk.scan.hint': 'Présentez le code QR de votre badge devant la caméra.',
    'kiosk.scan.allow': 'Autoriser la caméra',
    'kiosk.scan.noCamera': 'La caméra n’est pas disponible. Veuillez choisir votre nom dans la liste.',
    'kiosk.scan.notBadge': 'Ce n’est pas un badge CloudSign. Veuillez réessayer.',
    'kiosk.scan.notSignedIn': 'Ce badge n’est pas enregistré ici. Veuillez choisir votre nom dans la liste.',
    'kiosk.finish.inTitle': 'Merci, {name}',
    'kiosk.finish.inMessage': 'Votre arrivée est enregistrée.',
    'kiosk.finish.outTitle': 'Au revoir, {name}',
    'kiosk.finish.outMessage': 'Votre départ est enregistré. Bon retour !',
    'kiosk.finish.tap': 'Touchez pour terminer',
    'kiosk.update.title': 'Ce kiosque doit être mis à jour',
    'kiosk.update.message': 'Ce kiosque doit être mis à jour avant de pouvoir enregistrer votre arrivée. Veuillez demander à l’accueil.',
    'kiosk.update.short': 'Mise à jour nécessaire',
    'kiosk.error.required': 'Veuillez répondre à cette question.',
    'kiosk.error.mustAcknowledge': 'Veuillez cocher pour confirmer.',
    'kiosk.error.nameRequired': 'Veuillez saisir votre nom.',
    'kiosk.error.fullName': 'Veuillez indiquer votre prénom et votre nom de famille.',
    'kiosk.error.tooLong': 'Cette réponse est trop longue.',
    'kiosk.error.number': 'Veuillez saisir un nombre.',
    'kiosk.error.wholeNumber': 'Veuillez saisir un nombre entier.',
    'kiosk.error.range': 'Ce nombre n’est pas dans la plage autorisée.',
    'kiosk.error.email': 'Veuillez saisir une adresse e-mail valide.',
    'kiosk.error.phone': 'Veuillez saisir un numéro de téléphone valide.',
    'kiosk.error.date': 'Veuillez saisir une date au format 2026-12-31.',
    'kiosk.error.answerNotAllowed': 'Cette réponse ne vous permet pas d’être enregistré ici. Veuillez vous adresser à l’accueil.',
    'kiosk.print.state.ready': 'L’imprimante est prête',
    'kiosk.print.state.no_media': 'L’imprimante n’a plus d’étiquettes',
    'kiosk.print.state.cover_open': 'Le capot de l’imprimante est ouvert',
    'kiosk.print.state.media_mismatch': 'Les mauvaises étiquettes sont chargées dans l’imprimante',
    'kiosk.print.state.busy': 'L’imprimante est occupée',
    'kiosk.print.state.error': 'L’imprimante signale un problème',
    'kiosk.print.state.unreachable': 'L’imprimante est injoignable',
    'kiosk.print.state.unknown': 'L’état de l’imprimante est inconnu',
    'kiosk.home.expected': 'J’ai rendez-vous',
    'kiosk.home.scanCode': 'Scanner mon code QR',
    'kiosk.scan.titleCode': 'Scannez votre code QR',
    'kiosk.scan.hintCode': 'Présentez devant la caméra le code QR de votre e-mail, de votre carte ou de votre badge.',
    'kiosk.scan.invalid': 'Ce code QR n’est pas valide ici. Réessayez ou choisissez votre nom dans la liste.',
    'kiosk.scan.notSupported': 'Ce kiosque ne peut pas lire ce type de code QR. Veuillez choisir votre nom dans la liste.',
    'kiosk.scan.unknownMember': 'Ce code QR n’est pas reconnu sur ce kiosque. Veuillez choisir votre nom dans la liste.',
    'kiosk.scan.oldCode': 'Ce code QR a été remplacé par un nouveau. Veuillez utiliser le plus récent ou choisir votre nom.',
    'kiosk.scan.notHere': 'Ce code QR ne concerne pas ce kiosque.',
    'kiosk.scan.notExpected': 'Nous n’attendons pas ce code QR aujourd’hui. Veuillez vous adresser à l’accueil.',
    'kiosk.scan.cancelled': 'Cette visite a été annulée. Veuillez vous adresser à l’accueil.',
    'kiosk.scan.alreadyArrived': 'Ce code QR a déjà servi à enregistrer une arrivée.',
    'kiosk.scan.expired': 'Ce code QR a expiré. Veuillez vous adresser à l’accueil.',
    'kiosk.expected.title': 'Qui êtes-vous ?',
    'kiosk.expected.search': 'Commencez à saisir votre nom',
    'kiosk.expected.exactHint': 'Veuillez saisir votre nom complet exactement tel qu’il nous a été communiqué.',
    'kiosk.expected.requiredHint': 'Vous devez être attendu pour vous enregistrer ici. Trouvez votre nom ou scannez votre code QR.',
    'kiosk.expected.none': 'Nous n’avons pas trouvé ce nom sur la liste du jour. Veuillez vous adresser à l’accueil.',
    'kiosk.expected.empty': 'Aucune personne n’est attendue pour le moment.',
    'kiosk.expected.visiting': 'Visite de {host}',
    'kiosk.expected.required': 'Vous devez être attendu pour vous enregistrer ici. Veuillez vous adresser à l’accueil.',
    'kiosk.signout.outMark': 'Sorti',
    'kiosk.signout.outToday': 'Départ enregistré aujourd’hui',
    'kiosk.hostReply.on_my_way': '{host} est en route.',
    'kiosk.hostReply.please_wait': '{host} vous demande de bien vouloir patienter.',
    'kiosk.hostReply.someone': 'Votre contact',
    'kiosk.hostReply.dismiss': 'OK',
    'kiosk.evacuation.notAllowed': 'Une évacuation ne peut pas être lancée depuis ce kiosque.',
    'kiosk.evacuation.wrongPin': 'Ce code PIN n’est pas correct.',
    'kiosk.evacuation.pinLocked': 'Trop de codes PIN incorrects. Veuillez patienter quelques minutes.',
    'kiosk.evacuation.startFailed': 'L’évacuation n’a pas pu être lancée. Veuillez réessayer.',
    'kiosk.nfc.enrolOffline': 'Ce kiosque est hors connexion. Les cartes ne peuvent être enregistrées que lorsqu’il est connecté.',
    'kiosk.nfc.enrolExpired': 'Cet enregistrement de carte est terminé ou a expiré.',
    'kiosk.nfc.enrolFailed': 'Cette carte n’a pas pu être enregistrée. Veuillez en essayer une autre.',
    'kiosk.nfc.enrolTapAgain': 'Veuillez présenter à nouveau la carte.',
    'kiosk.common.ok': 'OK',
    'kiosk.welcome.stale': 'Ce kiosque est hors connexion depuis longtemps. Veuillez le signaler à l’accueil.',
    'kiosk.welcome.busy': 'Le site est très fréquenté en ce moment. Si vous venez en visite, veuillez le signaler à l’accueil.',
    'kiosk.welcome.evacuation': 'Évacuation',
    'kiosk.home.delivery': 'Je viens livrer un colis',
    'kiosk.check.seeReceptionTitle': 'Veuillez vous adresser à l’accueil',
    'kiosk.check.warnTitle': 'Avant de continuer',
    'kiosk.full.short': 'Le site est complet',
    'kiosk.full.title': 'Le site est complet',
    'kiosk.full.message': 'Nous ne pouvons pas enregistrer davantage de visiteurs pour le moment. Veuillez vous adresser à l’accueil.',
    'kiosk.induction.subtitle': 'Formation d’accueil sur site',
    'kiosk.induction.unavailable': 'La formation d’accueil n’est pas disponible sur ce kiosque. Veuillez vous adresser à l’accueil.',
    'kiosk.induction.videoMissing': 'La vidéo n’est pas encore sur ce kiosque. Veuillez lire le texte ci-dessous.',
    'kiosk.induction.pdfNote': 'Veuillez lire le texte de la formation ci-dessous. Demandez à l’accueil si vous souhaitez le document.',
    'kiosk.induction.wait': 'Veuillez patienter {seconds} secondes',
    'kiosk.induction.startQuiz': 'Commencer les questions',
    'kiosk.induction.question': 'Question {n} sur {total}',
    'kiosk.induction.chooseMany': 'Choisissez toutes les réponses correctes.',
    'kiosk.induction.finish': 'Terminer',
    'kiosk.induction.retryTitle': 'Pas tout à fait',
    'kiosk.induction.retryMessage': 'Certaines réponses étaient incorrectes. Veuillez réessayer {count} question(s).',
    'kiosk.induction.retryButton': 'Réessayer',
    'kiosk.permits.title': 'Vos autorisations de travail',
    'kiosk.permits.unavailable': 'Vos autorisations ne peuvent pas être affichées pour le moment. Veuillez vous adresser à l’accueil avant de commencer le travail.',
    'kiosk.permits.allAccepted': 'Vous avez accepté toutes vos autorisations.',
    'kiosk.permits.progress': 'Autorisation {n} sur {total}',
    'kiosk.permits.valid': 'Du {from} au {until}',
    'kiosk.permits.conditions': 'Conditions',
    'kiosk.permits.precautions': 'Précautions',
    'kiosk.permits.signHere': 'Signez ici pour accepter, {name}',
    'kiosk.permits.accept': 'J’accepte cette autorisation',
    'kiosk.nfc.blocked': 'Cette carte a été bloquée',
    'kiosk.nfc.unknown': 'Carte non reconnue',
    'kiosk.nfc.enrolTitle': 'Enregistrement des cartes',
    'kiosk.nfc.enrolProgress': '{done} sur {total} terminé(s)',
    'kiosk.nfc.enrolTapFor': 'Présentez la carte pour',
    'kiosk.nfc.enrolHold': 'Placez la carte contre l’arrière de la tablette.',
    'kiosk.nfc.enrolSaving': 'Enregistrement…',
    'kiosk.nfc.enrolOk': 'Carte enregistrée.',
    'kiosk.nfc.enrolDone': 'Toutes les cartes sont enregistrées',
    'kiosk.nfc.noReader': 'Aucun lecteur de carte n’est activé sur ce kiosque.',
    'kiosk.evacuation.title': 'ÉVACUATION',
    'kiosk.evacuation.drillTitle': 'EXERCICE INCENDIE',
    'kiosk.evacuation.startTitle': 'Lancer une évacuation',
    'kiosk.evacuation.confirmTitle': 'Lancer une évacuation ?',
    'kiosk.evacuation.confirmMessage': 'Cela alerte toutes les personnes présentes sur le site et ouvre l’appel.',
    'kiosk.evacuation.confirmStart': 'Lancer l’évacuation',
    'kiosk.evacuation.leave': 'Quitter l’appel',
    'kiosk.evacuation.leaveTitle': 'Saisissez le code PIN pour quitter l’appel',
    'kiosk.evacuation.returnBanner': 'Évacuation en cours. Touchez pour revenir à l’appel.',
    'kiosk.evacuation.offline': 'Hors connexion : vos pointages sont sauvegardés et seront envoyés dès le retour du réseau.',
    'kiosk.evacuation.localOnly': 'Lancée sur ce kiosque hors connexion. Elle sera fusionnée avec le portail dès le retour du réseau.',
    'kiosk.evacuation.countUnaccounted': 'Pas encore trouvé',
    'kiosk.evacuation.countSafe': 'En sécurité',
    'kiosk.evacuation.countMissing': 'Manquant',
    'kiosk.evacuation.countTotal': 'Sur site',
    'kiosk.evacuation.allPoints': 'Tout le monde',
    'kiosk.evacuation.search': 'Rechercher par nom',
    'kiosk.evacuation.onlyOpen': 'Pas encore en sécurité',
    'kiosk.evacuation.loading': 'Chargement de l’appel…',
    'kiosk.evacuation.nobody': 'Personne à afficher.',
    'kiosk.evacuation.safe': 'En sécurité',
    'kiosk.evacuation.markedSafe': 'EN SÉCURITÉ (touchez pour annuler)',
    'kiosk.evacuation.missing': 'Manquant',
    'kiosk.evacuation.markedMissing': 'MANQUANT (touchez pour annuler)',
    'kiosk.evacuation.host': 'Contact : {name}',
    'kiosk.evacuation.check': 'VÉRIFIER',
    'kiosk.evacuation.permits': '{count} autorisation(s) ouverte(s)',
    'kiosk.contactless.qrLabel': 'Scannez ce code avec votre téléphone pour vous enregistrer',
    'kiosk.contactless.scanMe': 'Enregistrez-vous avec votre téléphone',
    'kiosk.courier.whoTitle': 'Pour qui est le colis ?',
    'kiosk.courier.whoHint': 'Saisissez quelques lettres de son nom.',
    'kiosk.courier.search': 'Nom de la personne',
    'kiosk.courier.useName': 'Utiliser « {name} »',
    'kiosk.courier.useNameHint': 'L’accueil le transmettra',
    'kiosk.courier.carrierTitle': 'De quelle société venez-vous ?',
    'kiosk.courier.forName': 'Colis pour {name}',
    'kiosk.courier.other': 'Autre',
    'kiosk.courier.otherLabel': 'Nom de la société',
    'kiosk.courier.countTitle': 'Combien de colis ?',
    'kiosk.courier.howMany': 'Nombre de colis',
    'kiosk.courier.save': 'Terminé',
    'kiosk.courier.thanks': 'Merci',
    'kiosk.courier.thanksMessage': 'Nous avons informé le destinataire que son colis est arrivé.',
    'kiosk.support.pinTitle': 'Assistance : saisissez le code PIN',
    'kiosk.support.title': 'Assistance',
    'kiosk.support.close': 'Fermer',
    'kiosk.support.network': 'Réseau',
    'kiosk.support.online': 'En ligne',
    'kiosk.support.offline': 'Hors connexion',
    'kiosk.support.queue': 'En attente d’envoi',
    'kiosk.support.oldest': 'Le plus ancien en attente depuis',
    'kiosk.support.none': 'Aucun',
    'kiosk.support.deadLetters': 'Refusés par le serveur (non envoyés)',
    'kiosk.support.deadHelp': 'Ces éléments ont été refusés par le serveur et restent sur ce kiosque. Informez votre administrateur ; la page de l’appareil dans le portail indique leur nombre.',
    'kiosk.support.configAge': 'Paramètres mis à jour',
    'kiosk.support.ageUnknown': 'Jamais',
    'kiosk.support.ageMinutes': 'il y a {n} minutes',
    'kiosk.support.ageHours': 'il y a {n} heures',
    'kiosk.support.ageDays': 'il y a {n} jours',
    'kiosk.support.nfc': 'Lecteur de cartes',
    'kiosk.support.nfcReady': 'Prêt',
    'kiosk.support.nfcOff': 'Désactivé',
    'kiosk.support.nfcNone': 'Non installé',
    'kiosk.support.media': 'Vidéos stockées',
    'kiosk.support.mediaMb': '{mb} Mo',
    'kiosk.support.headcount': 'Personnes sur site (ce kiosque)',
    'kiosk.finish.poweredBy': 'Propulsé par CloudSign',
    'kiosk.badge.noMedia': 'L’imprimante à badges n’a plus d’étiquettes. Votre arrivée est enregistrée. Veuillez en informer l’accueil.',
    'kiosk.badge.mediaMismatch': 'L’imprimante à badges contient les mauvaises étiquettes. Votre arrivée est enregistrée. Veuillez en informer l’accueil.',
    'kiosk.badge.coverOpen': 'Le capot de l’imprimante à badges est ouvert. Votre arrivée est enregistrée. Veuillez en informer l’accueil.',
    'kiosk.member.menuTitle': 'Que souhaitez-vous faire ?',
    'kiosk.member.signIn': 'Enregistrer mon arrivée',
    'kiosk.member.updatePhoto': 'Mettre à jour ma photo',
    'kiosk.member.sendInvite': 'M’envoyer l’invitation à l’application',
    'kiosk.memberPhoto.title': 'Mettre à jour votre photo',
    'kiosk.memberPhoto.saved': 'Votre photo a été mise à jour.',
    'kiosk.memberPhoto.failed': 'Votre photo n’a pas pu être enregistrée. Veuillez réessayer ou vous adresser à l’accueil.',
    'kiosk.memberPhoto.offline': 'Ce kiosque est hors connexion : votre photo ne peut pas être mise à jour pour le moment.',
    'kiosk.memberPhoto.notAllowed': 'Votre photo ne peut pas être mise à jour sur le kiosque. Veuillez vous adresser à l’accueil.',
    'kiosk.invite.title': 'Obtenir l’application CloudSign',
    'kiosk.invite.sent': 'Nous vous avons envoyé par e-mail un lien pour configurer l’application. Veuillez vérifier votre boîte de réception.',
    'kiosk.invite.noEmail': 'Nous n’avons pas d’adresse e-mail pour vous, nous ne pouvons donc pas envoyer d’invitation. Veuillez vous adresser à l’accueil.',
    'kiosk.invite.tooMany': 'Vous avez demandé trop d’invitations aujourd’hui. Veuillez réessayer demain.',
    'kiosk.invite.failed': 'L’invitation n’a pas pu être envoyée. Veuillez réessayer ou vous adresser à l’accueil.',
    'kiosk.invite.offline': 'Ce kiosque est hors connexion : une invitation ne peut pas être envoyée pour le moment.',
    'kiosk.invite.sending': 'Envoi de votre invitation…',
    'kiosk.language.choose': 'Choisissez votre langue',
    'kiosk.language.button': 'Langue',
    'public.language.label': 'Langue',
    'contactless.thank_you': 'Merci. Votre arrivée est enregistrée.',
    'contactless.thank_you_out': 'Merci. Votre départ est enregistré.',
    'contactless.poster.title': 'Scannez pour vous enregistrer',
    'contactless.poster.hint': 'Pointez l’appareil photo de votre téléphone vers le code. Aucune application n’est nécessaire.',
    'check.safety_check.refused': 'Veuillez vous adresser à l’accueil avant de vous enregistrer.',
    'check.safety_check.alert': 'Admis avec une alerte envoyée à l’accueil (contrôle de sécurité).',
    'check.compliance.refused': 'Un document requis est manquant ou a expiré. Veuillez vous adresser à l’accueil.',
    'check.compliance.warned': 'Un document requis est manquant ou a expiré.',
    'check.induction.required': 'Veuillez d’abord suivre la formation d’accueil sur site.',
    'check.capacity.full': 'Le site est complet pour le moment. Veuillez vous adresser à l’accueil.',
    'check.capacity.warned': 'Enregistré alors que le site dépassait sa capacité.',
    'check.offline': 'Enregistré pendant que le kiosque était hors connexion.',
};
//# sourceMappingURL=fr.js.map